import { useMemo } from 'react';

import { AgeGroupsOrder, DataFilters, DataType } from '../types';
import { LocalizedFilter, localizeFilters } from '../utility/ai-chat-content';

function useLocalizedFilters(
    dataType: DataType,
    filters: DataFilters,
    ageGroupsOrder?: AgeGroupsOrder | null
): LocalizedFilter[] {
    return useMemo(
        () => localizeFilters(filters, dataType, ageGroupsOrder),
        [filters, dataType, ageGroupsOrder]
    );
}

export default useLocalizedFilters;
